'use client'

import { MediaFlowPage } from '@flowx/media-flow/client'
import ProtectedRoute from '@/components/auth/ProtectedRoute'

export default function MediaFlowRoute() {
  return (
    <ProtectedRoute>
      <MediaFlowPage />
    </ProtectedRoute>
  )
}
